import { render } from "./GlassButton.vue?vue&type=template&id=def0cd34&scoped=true&ts=true"
import script from "./GlassButton.vue?vue&type=script&lang=ts"
export * from "./GlassButton.vue?vue&type=script&lang=ts"

import "./glass-button.scss?vue&type=style&index=0&id=def0cd34&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def0cd34"]])

export default __exports__